export enum GalleryAccessType {
    Undefined = 0,
    All = 1,
    Registered = 2,
    CheckedIn = 3
}
